import { render } from "./MyQuestions.vue?vue&type=template&id=a66c8b46&scoped=true"
import script from "./MyQuestions.vue?vue&type=script&lang=js"
export * from "./MyQuestions.vue?vue&type=script&lang=js"

import "./MyQuestions.vue?vue&type=style&index=0&id=a66c8b46&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a66c8b46"]])

export default __exports__